<template>

<div class="head">

	<com-logo />

    <div class="head-divide" />

    <com-search />
    <com-voting v-if="!$isMobile" />
    <com-access v-if="!$isMobile" />
    <com-patreon />
    <com-inbox />
    <com-groups v-if="loggedin" />
    <com-account />

</div>

</template>

<script>

import comLogo from './head/Logo'
import comAccount from './head/Account'
import comAccess from './head/Access'
import comPatreon from './head/Patreon'
import comVoting from './head/Voting'
import comInbox from './head/Inbox'
import comSearch from './head/Search'
import comGroups from './head/Groups'

export default {

    components: {
        'com-logo': comLogo,
        'com-inbox': comInbox,
        'com-voting': comVoting,
        'com-access': comAccess,
        'com-patreon': comPatreon,
        'com-groups': comGroups,
        'com-account': comAccount,
        'com-search': comSearch
    }
	
}

</script>

<style scoped>

.head {
    background-color: #082534;
    position: fixed;
    top: 0px;
    height: 64px;
    left: 0px;
    padding: 0px 0px 0px 0px;
    width: 100%;
    z-index: 10000;
    display: flex;
}

.head-divide {
    flex-grow: 1;
}

.is-mobile .head {
    height: 48px;
}

</style>
